import { usePromisedRequest as promiseRequest } from "../Common/request";
import { resolveWithBody } from "./Utils/utils";

//Source: Panel\StartingLists\Model\SharingType (case names)
export type StartingListsSharingType =
    | "DisableStartingLists"
    | "ShowAllCompetitors"
    | "ShowNotDisqualified"
    | "ShowAllAndMarkDisqualified"
    | "ShowOnlyVerified";

//Source: Panel\StartingLists\Sharing\StartingListsSharingState
export type StartingListsSharingState = {
    sharingType: StartingListsSharingType;
    publicUrl: string;
};

//Source: Panel\StartingLists\Sharing\UpdateStartingListsSharingRequest
export type UpdateStartingListsSharingRequest = {
    sharingType: StartingListsSharingType;
};

export interface StartingListCompetitor {
    publicId: string | null;
    firstName: string;
    lastName: string;
    academy: string;
    academyId: number;
    branch: string;
    nationality: string | null;
    isDisqualifiedForNoPayment: boolean;
    photoUrl: string | null;
}

export interface StartingListCategory {
    parameterId: number;
    category: string;
    competitors: StartingListCompetitor[];
}

export interface StartingListsResponse {
    sharingType: number;
    lastUpdate: string | null;
    categories: StartingListCategory[];
}

export default {
    getPublicStartingLists(eventId: number): Promise<StartingListsResponse> {
        return promiseRequest<StartingListsResponse>({
            url: `/api/events/${eventId}/starting-lists/public`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },

    getSharing(eventId: number): Promise<StartingListsSharingState> {
        return promiseRequest<StartingListsSharingState>({
            url: `/api/admin/events/${eventId}/starting-lists/sharing`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },

    changeSharingType(eventId: number, request: UpdateStartingListsSharingRequest): Promise<StartingListsSharingState> {
        return promiseRequest<StartingListsSharingState>({
            url: `/api/admin/events/${eventId}/starting-lists/actions/change-sharing-type`,
            method: "put",
            json: request,
        }).then(resolveWithBody());
    },
};
